module.exports = __webpack_public_path__ + "static/media/01.b97e01df.png";